const LONGEST_RECORD_ID = 24;
const HIDDEN_SEGMENT = ":secret";

export function loggablePath(url: string | undefined): string | undefined {
    return url
        ?.split(/[?#]/)[0]
        .split("/")
        .map((segment) =>
            segment.length > LONGEST_RECORD_ID ? HIDDEN_SEGMENT : segment,
        )
        .join("/");
}
